import { RevisionHistoryDialogCtrl } from '../controllers/RevisionHistoryDialogCtrl';
import { IActionContext } from '../helpers/ActionContext';
import { ResultHelper } from '../helpers/ResultHelper';
import { DatasourceContentType, FlowContentType, IContentType, WorkbookContentType } from '../models/ContentTypes';
import { Module } from '../Module';
import { DatasourceRevisions } from '../resources/DatasourceRevisions';
import { FlowRevisions } from '../resources/FlowRevisions';
import { WorkbookRevisions } from '../resources/WorkbookRevisions';
import { FlowRevision, IContentRevision, IDataSourceRevision, IWorkbookRevision } from '../ServerApi/types/IContentRevision';
import { IResult } from '../ServerApi/types/IResponse';
import { ConfirmActionDialog, IConfirmActionDialogInstance } from './ConfirmActionDialog';
import { ToasterService, ToastType } from './ToasterService';

export class DeleteRevisionAction {

    public static $inject = ['$translate',
        'ConfirmActionDialog',
        'ToasterService',
        'DatasourceRevisions',
        'FlowRevisions',
        'WorkbookRevisions'];

    constructor(
        private $translate: ng.translate.ITranslateService,
        private ConfirmActionDialog: ConfirmActionDialog,
        private toasterService: ToasterService,
        private DatasourceRevisions: DatasourceRevisions,
        private FlowRevisions: FlowRevisions,
        private WorkbookRevisions: WorkbookRevisions) { }

    public showDeleteWorkbookRevisionDialog(revision: IWorkbookRevision, context: IActionContext): ng.IPromise<any> {
      return this.showDeleteRevisionDialog(revision, context, WorkbookContentType);
    }

    public showDeleteDataSourceRevisionDialog(revision: IDataSourceRevision, context: IActionContext): ng.IPromise<any> {
      return this.showDeleteRevisionDialog(revision, context, DatasourceContentType);
    }

    public showDeleteFlowRevisionDialog(revision: FlowRevision, context: IActionContext): ng.IPromise<any> {
      return this.showDeleteRevisionDialog(revision, context, FlowContentType);
    }

    private showDeleteRevisionDialog(revision: IContentRevision, context: IActionContext, contentType: IContentType): ng.IPromise<any> {
      let successTextTemplate: string;

      switch (contentType) {
        case WorkbookContentType:
          successTextTemplate = 'deleteWorkbookRevisionSuccess';
          break;
        case DatasourceContentType:
          successTextTemplate = 'deleteDataSourceRevisionSuccess';
          break;
        case FlowContentType:
          successTextTemplate = 'deleteFlowRevisionSuccess';
          break;
        default:
          throw new Error(this.$translate.instant('revisionHistoryUnsupportedContentType'));
      }

      const revisionHistoryScope = (<RevisionHistoryDialogCtrl.Scope>context.scope);

      return this.ConfirmActionDialog.open({
        scope: context.scope,
        title: this.$translate.instant('deleteMessage'),
        bodyText: this.$translate.instant('deleteRevisionConfirm'),
        actionName: this.$translate.instant('deleteMessage'),
        isDeleteAction: true,
        action: (dialogInstance: IConfirmActionDialogInstance) => {
          let deleteRequest;
          switch (contentType) {
            case WorkbookContentType:
              deleteRequest = this.WorkbookRevisions.del;
              break;
            case DatasourceContentType:
              deleteRequest = this.DatasourceRevisions.del;
              break;
            case FlowContentType:
              deleteRequest = this.FlowRevisions.del;
              break;
            default:
              throw new Error(this.$translate.instant('revisionHistoryUnsupportedContentType'));
          }

          return deleteRequest(revision.id).then(
            (result: IResult) => {
              if (ResultHelper.hasErrors(result)) {
                this.toasterService.pop({ type: ToastType.Error, text: this.$translate.instant('deleteRevisionError') });
              } else {
                this.toasterService.pop({ type: ToastType.Info, text: this.$translate.instant(successTextTemplate) });
              }
            }
          );
        }
      }).result.then(() => {
        this.deselectDeletedRevision(revision, revisionHistoryScope);
      });
    }

    private deselectDeletedRevision(deletedRevision: IContentRevision, revisionHistoryScope: RevisionHistoryDialogCtrl.Scope) {
      if (deletedRevision.id === revisionHistoryScope.selectedItems.first().id) {
        revisionHistoryScope.selectedItems.remove(deletedRevision);
      }
    }
}

Module.instance().service('DeleteRevisionAction', DeleteRevisionAction);
